<template>
    <div class="reset">
        <b-container class="box">
            <b-row>
                <b-col></b-col>
                <b-col cols="6" class="center">
                    <div class="login-line"></div>
                    <form class="form" v-on:submit.prevent="onSubmit()">
                        <h3>Cambia la password</h3>
                        <br>
                        <b-form-input class="login-input" type="password" v-model="oldPass" placeholder="Password attuale" :state="state.oldPass"></b-form-input>
                        <b-form-input class="login-input" type="password" v-model="newPass1" placeholder="Nuova password" :state="state.newPass1"></b-form-input>
                        <b-form-input class="login-input" type="password" v-model="newPass2" placeholder="Reinserisci la nuova password" :state="state.newPass2"></b-form-input>
                        <b-button type="submit" class="login-submit">Cambia Password</b-button>
                    </form>
                </b-col>
                <b-col></b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import Vue from 'vue'

export default {
  name: 'reset',
  data() {
    return {
        oldPass: '',
        newPass1: '',
        newPass2: '',
        state: {
            oldPass: null,
            newPass1: null,
            newPass2: null,
        }
    }
  },
  methods: {
        onSubmit() {
            if(this.oldPass == '' || this.oldPass == this.newPass1 || this.oldPass == this.newPass2){
                this.state.oldPass = false
            }else
               this.state.oldPass = null 

            if(this.newPass1 == '' || this.newPass1 != this.newPass2 || this.oldPass == this.newPass1){
                this.state.newPass1 = false
            }else
                this.state.newPass1 = null

            if(this.newPass2 == '' || this.newPass1 != this.newPass2 || this.oldPass == this.newPass2){
                this.state.newPass2 = false
            }else
                this.state.newPass2 = null

            if(this.oldPass != '' && this.newPass1 != '' && this.newPass2 != '' &&
                this.newPass1 == this.newPass2 && this.oldPass != this.newPass1 && this.oldPass != this.newPass2){
                this.state.oldPass = null
                this.state.newPass1 = null
                this.state.newPass2 = null
                
                Vue.http.post(this.$hostlink+'user/reset', {oldPass: this.oldPass, newPass1: this.newPass1, newPass2: this.newPass2}, {credentials : true}).then(response => {
                    if(response.body.success){
                        Vue.notify({
                            group: 'global',
                            title: 'Cambio password effettuato',
                            text: 'Cambio della password eseguito con successo!',
                            type: 'success'
                        })
                        this.$router.push('/home')
                    }else{
                        Vue.notify({
                            group: 'global',
                            title: 'Errore durante il cambio della password',
                            text: response.body.msg,
                            type: 'error'
                        })
                    }
                }, response => {
                    Vue.notify({
                        group: 'global',
                        title: 'Errore!',
                        text: 'Qualcosa è andato storto!',
                        type: 'error'
                    })
                })
            }else{
                Vue.notify({
                    group: 'global',
                    title: 'Errore durante il cambio della password',
                    text: 'Assicurati di aver inserito correttamente tutti i dati!',
                    type: 'error'
                })
            }
        }
    }
}
</script>

<style>
.reset{
    background-image: linear-gradient(to bottom right, #085078, #85D8CE);
    height: 100vh;
}

.box{
    padding-top: 30vh;
}

.form{
    background: white;
    padding: 40px !important;
}

.password{
    background: white;
    padding: 40px !important;
}

.center{
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    padding: 0 !important;
}

.login-input{
    background: #d3d3d3 !important;
    margin-bottom: 20px;
    height: 50px !important;
}

.login-input:focus { 
    background: white !important;
}

.login-submit{
    background-color: #085078 !important;
    width: 100%;
    height: 50px;
}

.login-checkbox{
    margin-bottom: 20px;
}

.login-line{
    background: #085078;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    width: 100%;
    height: 4px;
}

@media only screen and (max-width: 600px) {
    .box{
        padding-top: 25vh;
    }

    .center{
        height: 50vh;
        width: 90vw;
    }
}
</style>
